import { ProgressSpinner } from "primereact/progressspinner";
import { Avatar } from "primereact/avatar";
import Statistic from "./Statistic";
import { useTranslation } from 'react-i18next';
export default function Statistics(props) {
  const { data, fetchInProgress } = props;
  const { t } = useTranslation();
  const STATISTICS=t("STATISTICS")
  return (
    <main id="statistics" className="main-page">
      <section className="page-section q-pa-md">
        <div className="container-fluid">
          <div className="w-full mt-6 card" style={{ padding: '0px' }}>
            <div className="p-5" style={{ borderBottom: '1px solid #e5e7eb'}}>
              <div className="flex gap-2 align-items-center">
                <Avatar
                  icon="pi pi-chart-bar"
                  className="bg-[#fff]"
                  size="xlarge"
                />
                <h5 className="dark:text-dark-tremor-content-strong">
                  {STATISTICS}
                </h5>
              </div>
            </div>
            <div className="p-5 flex flex-column">
              {fetchInProgress ? (
                <ProgressSpinner />
              ) : (
                data.map((statistic, index) => {
                  const { key, title, count } = statistic;
                  const isLastElement = index === data.length - 1;
                  return (
                    <Statistic
                      title={title}
                      count={count}
                      key={key}
                      isLastElement={isLastElement}
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
